import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, reactive, watch, withDefaults } from 'vue';

export type StrokeStyle = 'solid' | 'dashed';

interface Props {
  map: google.maps.Map;
  paths: google.maps.MVCArray<google.maps.LatLng>[];
  fillColor?: string;
  fillOpacity?: number;
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
  strokeStyle?: StrokeStyle;
  geodesic?: boolean;
  visible?: boolean;
  zIndex?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMapsPolygon',
  props: {
    map: null,
    paths: null,
    fillColor: { default: '#555555' },
    fillOpacity: { default: 0.7 },
    strokeColor: { default: '#555555' },
    strokeOpacity: { default: 1 },
    strokeWeight: { default: 2 },
    strokeStyle: { default: 'solid' },
    geodesic: { type: Boolean, default: true },
    visible: { type: Boolean, default: true },
    zIndex: { default: 10 }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { map: google.maps.Map, paths: google.maps.MVCArray<google.maps.LatLng>[], fillColor: string, fillOpacity: number, strokeColor: string, strokeOpacity: number, strokeWeight: number, strokeStyle: StrokeStyle, geodesic: boolean, visible: boolean, zIndex: number }

// TODO: this component should be refactored to be like GoogleMapsLabel.vue


const polygon = reactive<google.maps.Polygon>(
  new google.maps.Polygon({
    map: props.map,
    paths: props.paths,
    fillColor: props.fillColor,
    fillOpacity: props.fillOpacity,
    strokeColor: props.strokeColor,
    strokeOpacity: props.strokeStyle === 'dashed' ? 0 : props.strokeOpacity,
    strokeWeight: props.strokeWeight,
    geodesic: props.geodesic,
    visible: props.visible,
    zIndex: props.zIndex,
  }),
);



polygon.addListener('click', () => emit('click'));

/**
 * TODO okay solution, but this would imply that we have to implement a watcher for every property we define.
 * Optimally, we extend the google type and override the draw method just like in GoogleMapsLabel component.
 */
watch(
  () => props.fillColor,
  (fillColor) => polygon.setOptions({ fillColor }),
);

/* LIFECYCLE */

onUnmounted(() => {
  polygon.setMap(null);
});

return { __sfc: true,props, polygon, emit }
}

})